import { useQuery, UseQueryResult, useQueryClient, UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  getStructureTypesByCategoryCode,
  createStructureType,
  getStructureTypeByCode,
  updateStructureType,
  getStructureTypeByCodeForUpdate
} from '../api/structureTypes';
import { StructureTypeResponse } from '../@types';
import { StructureTypeByCodeKey, StructureTypeKey } from '../configs/structure-type';

export const useGetStructureTypesByCategoryCode = (catagoryCode: string): UseQueryResult<StructureTypeResponse[]> => {
  return useQuery({
    queryKey: [StructureTypeKey],
    queryFn: () => getStructureTypesByCategoryCode(catagoryCode),
    select: (response: any) => response,
    staleTime: 60 * 60 * 1000
  });
};

export const useCreateStructureType = (): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      return await createStructureType(data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [StructureTypeKey]
      });
    }
  });
};

export const useUpdateStructureType = (): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      return await updateStructureType(data.code, data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [StructureTypeKey]
      });
    }
  });
};

export const useGetStructureTypesByCode = (code: string): UseQueryResult<StructureTypeResponse> => {
  return useQuery({
    queryKey: [StructureTypeKey + code],
    queryFn: () => code !== '-1' && code !== '' && getStructureTypeByCode(code),
    select: (response: any) => response
  });
};

export const useGetStructureTypesByCodeForUpdate = (code: string): UseQueryResult<StructureTypeResponse> => {
  return useQuery({
    queryKey: [StructureTypeKey + code],
    queryFn: () => getStructureTypeByCodeForUpdate(code),
    select: (response: any) => response
  });
};

export const useGetStructureTypesExistanceByCode = (code: string): UseQueryResult<StructureTypeResponse> => {
  return useQuery({
    queryKey: [StructureTypeByCodeKey, code],
    queryFn: () => getStructureTypeByCodeForUpdate(code),
    select: (response: any) => response,
    retry: false,
    enabled: false
  });
};